// interfaces / types / consts
type IError = Error & {
  shortMessage?: string;
  info?: { error: { message: string } };
};

// exports
export function msgFromError(error: IError | string, defaultMsg = ''): string {
  // eslint-disable-next-line no-console
  if (typeof error !== 'string') { console.error('====== SBG_DEBUG_START ======\n', error, '\n====== SBG_DEBUG_END ======'); }
  return (typeof error === 'string') ? error
    : (defaultMsg || error.shortMessage || error.info?.error.message || error.message || 'something went wrong!');
}
export default { msgFromError };
